import React from 'react';
import { connect } from 'react-redux';
import ListEntry from './ListEntry/ListEntry';
import { START_TIME } from '../../../../../constants';
import './DayList.css';

// todo - entry.time as key is not ideal

function DayList({ weekdayId, dataDays, currentDayId, startDayId }) {
  const dayId = startDayId + weekdayId;
  let dayClass = 'day-list';
  let entries = null;
  let tip = null;
  // todo - temp solution - repeating computation
  const dayDate = new Date(
    START_TIME + (startDayId + weekdayId) * 24 * 60 * 60 * 1000
  );
  const dayData = dataDays[`${dayDate.getMonth()}-${dayDate.getDate() - 1}`]; // todo - dirty - check
  if (dayData && dayData.data.length > 0) {
    entries = dayData.data.map(entry => (
      <ListEntry
        key={`${weekdayId}-${entry.key}`}
        tip={false}
        entryData={entry}
      />
    ));
  }
  if (dayData && dayData.tip) {
    tip = <ListEntry tip entryData={dayData.tip} />;
  }

  if (dayId === currentDayId) {
    dayClass += ' current';
  }

  return (
    <div className={dayClass}>
      {tip}
      {entries}
    </div>
  );
}

const mapStateToProps = state => ({
  dataDays: state.dataDays,
  currentDayId: state.navigation.currentDayId,
  startDayId: state.navigation.startDayId
});

export default connect(mapStateToProps)(DayList);



// WEBPACK FOOTER //
// ./src/components/App/Program/List/DayList/DayList.js